import { SuperAgentResource } from './resource';

export { SuperagentResponse } from './resource';
export default SuperAgentResource;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/superagent/index.js
// module id = 1150
// module chunks = 0